export default "__VITE_ASSET__R$icrczF__"